<template>
  <div class="image-board">
    <img
      class     ="image"
      draggable ="false"
      v-if      ="visible"
      :src      ="currentImage"
      :style     ="{ '--scale': imageSize }"
    >
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ImageBoard',
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters('imageBoard', [
      'currentImage',
      'imageSize',
      'visible'
    ])
  }
}
</script>

<style scoped>
.image-board {
  position : absolute;
}
.image {
  z-index          : -1;
  top              : 0px;
  left             : 0px;
  position         : absolute;
  transform        : scale(calc(var(--scale) / 100));
  transform-origin : top left;
}
</style>



// WEBPACK FOOTER //
// src/components/image/content/index.vue